<template>
  <div class="sub-vue2-app">
    <header class="sub-vue2-app__header">
      <div>
        <p class="eyebrow">Vue2 Micro App</p>
        <h1>Child App Routes</h1>
      </div>

      <nav class="sub-vue2-app__nav">
        <router-link exact to="/">Overview</router-link>
        <router-link to="/insights">Insights</router-link>
        <router-link to="/todos">Todos</router-link>
      </nav>
    </header>

    <!-- 用户信息展示 - 从主应用同步的认证状态 -->
    <UserInfoCard />

    <router-view />
  </div>
</template>

<script>
import UserInfoCard from './components/UserInfoCard.vue'

export default {
  name: 'App',
  components: {
    UserInfoCard
  }
}
</script>

<style scoped>
.sub-vue2-app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.sub-vue2-app__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.eyebrow {
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #42b983;
  margin-bottom: 0.35rem;
}

.sub-vue2-app__header h1 {
  margin: 0;
}

.sub-vue2-app__nav {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.sub-vue2-app__nav a {
  text-decoration: none;
  color: #2c3e50;
  border: 1px solid #dbe7df;
  border-radius: 999px;
  padding: 0.45rem 0.8rem;
  background: #f8fbf9;
}

.sub-vue2-app__nav a.router-link-exact-active,
.sub-vue2-app__nav a.router-link-active {
  color: #ffffff;
  background: #2d7b5c;
  border-color: #2d7b5c;
}
</style>
